import { useState } from "react";
import { useDispatch } from "react-redux";
import { savedBlog } from "../../features/blog/blogSlice";

export default function SaveBtn({ id, saved }) {
  const dispatch = useDispatch();
  const [isSaved, setIsSaved] = useState(saved);

  const handleSaved = () => {
    setIsSaved(!isSaved);
    dispatch(savedBlog({ id, isSaved: !isSaved }));
  };

  return (
    <button
      className={`save-btn ${isSaved && "active "}`}
      id="lws-singleSavedBtn"
      onClick={handleSaved}
    >
      <i className="fa-regular fa-bookmark" /> Saved
    </button>
  );
}
